import React, { useEffect, useState } from "react";
import { Badge, Spinner } from "react-bootstrap";
import {
  getEmployeeSalaryDetailsApi,
  getEmployeeSalaryExportApi,
} from "../../../services/salaryService";
import { useParams } from "react-router-dom";
import { formatToIndianNumber, getYearsOptions } from "../../../utilities";
import { format } from "date-fns";
import GlobalSearchableDropdown from "../../Constant/SearchableDropdown";
import { MdFileDownload } from "react-icons/md";
import { CustomTooltip } from "../../../components/CustomTooltip";
import { BiSolidFileExport } from "react-icons/bi";
import { toast } from "react-toastify";
import { FaDownload } from "react-icons/fa";

const EmployeeSalary = () => {
  const { id } = useParams();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(getYearsOptions()[0]);
  const [exportLoading, setExportLoading] = useState(false);
  const getSalary = () => {
    setLoading(true);
    getEmployeeSalaryDetailsApi(id, selectedYear?.value || "")
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectedYear) {
      getSalary();
    }
  }, [selectedYear]);

  const handleExport = () => {
    setExportLoading(true);
    getEmployeeSalaryExportApi(id, {
      year: selectedYear?.value || "",
      export: true,
    })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Employee-salary-report.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };
  if (loading) {
    return (
      <div className="text-center mt-4">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger mt-3">{error}</div>;
  }
  return (
    <div>
      <div className="py-2 px-4 d-flex gap-2 justify-content-end">
        <div>
          <GlobalSearchableDropdown
            options={getYearsOptions()}
            selected={selectedYear}
            onSelect={(item) => setSelectedYear(item)}
            placeholder="Year"
            isClearable={false}
          />
        </div>
        <CustomTooltip title="Export">
          <button
            className="btn btn-success"
            style={{ padding: "0.45rem 0.6rem" }}
            onClick={handleExport}
            disabled={exportLoading}
          >
            {exportLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <FaDownload size="15" />
            )}
          </button>
        </CustomTooltip>
      </div>
      <div className="table-responsive">
        <table className="table fs-6 mb-0 align-middle">
          <thead className="table-light custom-thead">
            <tr>
              <th>Month</th>
              <th>Basic</th>
              <th>Allowances</th>
              <th>Deductions</th>
              <th>Net Salary</th>
              <th>Recieved</th>
              <th>Status</th>
              <th>Payment date</th>
            </tr>
          </thead>
          <tbody>
            {data.map((s, i) => (
              <tr key={i}>
                <td>{s?.month || "-"}</td>
                <td className="fw-semibold">
                  ₹{formatToIndianNumber(s?.base_salary)}
                </td>
                <td className="fw-semibold">
                  ₹{formatToIndianNumber(s?.overtime)}
                </td>
                <td className="text-danger fw-semibold">
                  -₹{formatToIndianNumber(s?.deductions)}
                </td>
                <td className="fw-semibold">
                  ₹{formatToIndianNumber(s?.net_salary)}
                </td>
                <td className="fw-semibold">
                  ₹{formatToIndianNumber(s?.paid_amount)}
                </td>
                <td>
                  <span
                    className={`badge rounded-2 ${
                      s?.payment_status?.toLowerCase() == "pending"
                        ? "text-bg-warning-soft"
                        : s?.payment_status?.toLowerCase() == "paid"
                        ? "text-bg-success-soft"
                        : "text-bg-danger-soft"
                    }`}
                  >
                    {s?.payment_status || "-"}
                  </span>
                </td>
                <td>{s?.paid_at ? format(s?.paid_at, "dd MMM yyyy") : "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployeeSalary;
